import React from "react";
import './Footer.css';

export default function Footer() {
    return (
        <div className="footer">
            Challenge by <a href="https://www.frontendmentor.io?ref=challenge"
                rel="noreferrer" target="_blank">&nbsp; Frontend Mentor</a>.
            By <a href="!#">&nbsp; Vitor Falcão</a>.
        </div>
    )
}